import { createSelector } from 'reselect';

import type { WebhookEventSubscription } from '../typescript-types/webhook-event-subscriptions/webhook-event-subscription';

import { StateDictionary } from '../reducers/utils/state-manager';

type WebhookEventSubscriptionDictionary = { [id: number]: WebhookEventSubscription };

export type WebhookEventSubscriptionState = {
  webhookEventSubscriptionsById: WebhookEventSubscriptionDictionary;
  webhookEventSubscriptionsStateByOrgId: StateDictionary;
};

type State = { webhookEventSubscriptions: WebhookEventSubscriptionState };

const webhookEventSubscriptionsByIdSelector = (state: State) =>
  state.webhookEventSubscriptions.webhookEventSubscriptionsById;
export const webhookEventSubscriptionsForOrgId = createSelector(
  [webhookEventSubscriptionsByIdSelector, (_state: State, orgId: number) => orgId],
  (subscriptionsById, orgId) =>
    Object.values(subscriptionsById || {})?.filter((sub) => sub.orgId === orgId),
);

const webhookEventSubscriptionsStateByOrgIdSelector = (state: State) =>
  state.webhookEventSubscriptions.webhookEventSubscriptionsStateByOrgId;
export const webhookEventSubscriptionsStateForOrgId = createSelector(
  [webhookEventSubscriptionsStateByOrgIdSelector, (_state: State, orgId: number) => orgId],
  (subscriptionsStateByOrgId, orgId) =>
    subscriptionsStateByOrgId ? subscriptionsStateByOrgId[orgId] : null,
);
